import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fires a gtag page_view on every route change. Needed because this is a
// single-page app — client-side navigation (react-router) never triggers
// gtag's own automatic page_view, so any page reached via navigate() rather
// than a fresh page load was never being tracked at all.
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== "function") return;

    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
};

export default AnalyticsTracker;
